// repo/primary-care-connect/frontend/src/pages/Portal/CommunityNavigator/CaseDetail/components/ClosureDetailsCard.tsx

import type { NavigatorCaseDetail } from "../types";
import { formatDateTime } from "../intakeUtils";
import DetailItem from "./DetailItem";

type ClosureDetailsCardProps = {
  caseDetail: NavigatorCaseDetail;
};

export default function ClosureDetailsCard({
  caseDetail,
}: ClosureDetailsCardProps) {
  if (!caseDetail.closedAt && !caseDetail.closedReason) {
    return null;
  }

  return (
    <section className="cn-case-detail-card cn-case-detail-wide">
      <div className="cn-case-detail-card-header">
        <h2>Closure details</h2>
      </div>

      <dl className="cn-case-detail-list cn-case-detail-list-two">
        <DetailItem
          label="Closed at"
          value={formatDateTime(caseDetail.closedAt)}
        />
        <DetailItem
          label="Closed reason"
          value={caseDetail.closedReason || "—"}
        />
      </dl>
    </section>
  );
}